import axios from "axios";
import { API_URL } from '../Constants';

class newUpdateDataService{
    inactivateRecord(apiToken, recordId) {
        return axios.post(`${API_URL}inactivateUpdateRequest/`, {apiToken, recordId});
    };
    activateRecord(apiToken, recordId) {
        return axios.post(`${API_URL}activateUpdateRequest/`, {apiToken, recordId});
    };
    getUpdateList(apiToken, filterObject) {
        return axios.post(`${API_URL}getUpdateRequestList/`,  filterObject, {headers:{'Authorization':apiToken}});
    };
    getSearchList(apiToken, filterObject) {
        return axios.post(`${API_URL}getUpdateSearchList/`,  filterObject, {headers:{'Authorization':apiToken}});
    };
    toggleUpdateFlag(apiToken, id) {
        return axios.post(`${API_URL}toggleUpdateFlag/`, {apiToken, id});
    };
    createUpdateRequest(apiToken, updateRequest) {
        return axios.post(`${API_URL}createUpdateRequest/`, updateRequest, {headers:{'Authorization':apiToken}});
    };
    getUpdateResultsList(apiToken, filterObject) {
        return axios.post(`${API_URL}getUpdateResultsList/`,  filterObject, {headers:{'Authorization':apiToken}});
    };
    getUpdateVendors(apiToken) {
        return axios.get(`${API_URL}getAllUpdateVendors/`, {headers:{'Authorization':apiToken}});
    };
    getUpdateCustomers(apiToken) {
        return axios.get(`${API_URL}getAllUpdateCustomers/`, {headers:{'Authorization':apiToken}});
    };
};

newUpdateDataService = new newUpdateDataService()
export default newUpdateDataService;